// extracted by mini-css-extract-plugin
export default {"pref":"Pref_pref__9njTL"};